 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"05d954cf","2":"5a797c6f96cad1ccec051781b3dcb6afab820224","3":"3ab25b009751aa10d15481456fd019d8d234153e","4":"f2345223cdef05c23ce7c9616e03d7ab5fe17948","5":"1a44daaee1409147467b6f1fa451e3f82a43ceac","6":"6cd98e570fc67742d216671ede4aec76007d89d8","7":"825ce33f9412e493b4d2e21f5dbce0be17f47b10","8":"8ee6d469774a8a03f25648fa7dfd646ab7225898","9":"b2d3d75d9adc27deb216a278f1c68246bc35fa5c","10":"f4027915a8bb8c51b20b82fa6b46671fb272da4d","12":"03a911f3","13":"2a0d3f8b","14":"34e8036e","15":"45531b93","16":"5b86344d","17":"6169590b","18":"65e1ec18","19":"6a1d62c8","20":"6f3cde06","21":"91472edf","22":"9c0b9651","23":"a0bae437","24":"abbe9e4c","27":"b70db833","28":"component---src-pages-404-js","29":"component---src-pages-about-js","30":"component---src-pages-book-js","31":"component---src-pages-career-js","32":"component---src-pages-community-js","33":"component---src-pages-coop-js","34":"component---src-pages-curation-js","35":"component---src-pages-escrow-js","36":"component---src-pages-fellowship-js","37":"component---src-pages-governance-js","38":"component---src-pages-incubator-js","39":"component---src-pages-index-js","40":"component---src-pages-integrations-js","41":"component---src-pages-juror-js","42":"component---src-pages-media-js","43":"component---src-pages-missing-locale-redirect-js","44":"component---src-pages-moderate-js","45":"component---src-pages-oracle-js","46":"component---src-pages-research-js","47":"component---src-pages-scout-js","48":"component---src-pages-token-js","49":"component---src-pages-treasury-js","50":"component---src-templates-bio-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"17be88073c500235d0ca","2":"c121a964db620183bf2f","3":"e4f50d51e4f643b699ce","4":"633a963d84b2f90f754a","5":"f9b4812955f4afb34de8","6":"f573490b5a40f17a768e","7":"be97ab566e288bfa4744","8":"81f3288e3526e9ed9348","9":"0291e646dda0d27e724a","10":"a6a6afc87eed8da98502","12":"1f8ce31128c54b05766f","13":"41b8fe703392fbc393e6","14":"91a9222ee7494280fdc4","15":"2fce1d95172d09abdb1f","16":"593a2e42e02ee1e4d1ef","17":"6fc2393515fe13d4b8f9","18":"f2001845d0fc1c715eac","19":"ccf48622f4e47e82dbda","20":"b9dfb360fa7e3915a74c","21":"6ad3e7de226f61d1b9ac","22":"95b434c85c4b5512a1a4","23":"67b0fafc193225bb65e7","24":"951f6a6a100b0137fb87","27":"95d2b06e7d37c51d86f8","28":"4fe68dca337cc3c6b32a","29":"080f4de78ee4b66bf173","30":"99adb468aace1fadc30c","31":"b690bd0cb3504f284392","32":"027c9eb3c4c16feb46b2","33":"a3f983b358890bc54aad","34":"d09fa6d9e30eafbb3c15","35":"501851a0a5878e7910aa","36":"cf4718a63e0736ff83ea","37":"1759134e980ccd88a542","38":"931fe58e545a0c934561","39":"eaaf1ec4917d6e869ad8","40":"6321b530a55269e25eed","41":"df3b1ea8a85b3c2fb6ec","42":"37a17879c61a6ae251f9","43":"cfefd8c5f1fb95cd71e7","44":"735958e79892197f9402","45":"cdddb9ba39b41b10f8c3","46":"812a575b5c56dbe5378b","47":"c57d04a94f89bbf824b9","48":"c0dcf5e12f352a4c029b","49":"845652f42196956061c1","50":"c4f9b102f141ef07e510"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"05d954cf","2":"5a797c6f96cad1ccec051781b3dcb6afab820224","3":"3ab25b009751aa10d15481456fd019d8d234153e","4":"f2345223cdef05c23ce7c9616e03d7ab5fe17948","5":"1a44daaee1409147467b6f1fa451e3f82a43ceac","6":"6cd98e570fc67742d216671ede4aec76007d89d8","7":"825ce33f9412e493b4d2e21f5dbce0be17f47b10","8":"8ee6d469774a8a03f25648fa7dfd646ab7225898","9":"b2d3d75d9adc27deb216a278f1c68246bc35fa5c","10":"f4027915a8bb8c51b20b82fa6b46671fb272da4d","12":"03a911f3","13":"2a0d3f8b","14":"34e8036e","15":"45531b93","16":"5b86344d","17":"6169590b","18":"65e1ec18","19":"6a1d62c8","20":"6f3cde06","21":"91472edf","22":"9c0b9651","23":"a0bae437","24":"abbe9e4c","27":"b70db833","28":"component---src-pages-404-js","29":"component---src-pages-about-js","30":"component---src-pages-book-js","31":"component---src-pages-career-js","32":"component---src-pages-community-js","33":"component---src-pages-coop-js","34":"component---src-pages-curation-js","35":"component---src-pages-escrow-js","36":"component---src-pages-fellowship-js","37":"component---src-pages-governance-js","38":"component---src-pages-incubator-js","39":"component---src-pages-index-js","40":"component---src-pages-integrations-js","41":"component---src-pages-juror-js","42":"component---src-pages-media-js","43":"component---src-pages-missing-locale-redirect-js","44":"component---src-pages-moderate-js","45":"component---src-pages-oracle-js","46":"component---src-pages-research-js","47":"component---src-pages-scout-js","48":"component---src-pages-token-js","49":"component---src-pages-treasury-js","50":"component---src-templates-bio-js"}[chunkId]||chunkId) + "." + {"0":"30851d41704fce0ece7f","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
